import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { EmpresaService } from '../shared/empresa.service';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';

@Component({
    selector: 'app-empresa-list',
    templateUrl: 'empresa-list.component.html',
})

export class EmpresaListComponent implements OnInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
    @Input() typeModule: TYPEMODULE;
    @Input() titlePage: string;
    @Input() data: any;

    pageSize: number;
    pageEvent: PageEvent;
    displayedColumns: string[] = ['ID', 'Name', 'DIRECCION', 'RUC', 'RAZON', 'ESTADO'];
    dataSource: GridDataSource;
    msgErrorGet: string;
    selectedRowIndex: number = -1;
    buttonGroup: any;
    showMessageGridEmpty: boolean = false;
    pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
    mostrarBotonNuevo: boolean = false;

    constructor(private loaderService: LoaderService,
        private empresaService: EmpresaService,
        private notificationService: NotificationService,
        private sessionInfo: SessionInfo,
    ) { }

    ngOnInit() {
        this.pageSize = 0; //CONSTANT.pageSize;
        this.pageEvent = new PageEvent();
        this.clearMatPaginator();
        this.msgErrorGet = 'Error al listar las empresas';
        this.buttonGroup = [
            { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
        ];
        this.mostrarBotonNuevo = CONSTANT.kMicrobankId == this.sessionInfo.getEmpresaID();
    }

    handleRowClick(row: any, event: any) {
        if (event.srcElement.cellIndex) {
            if (event.srcElement.cellIndex != 0) {
                this.selectedRowIndex = row.ID;
                this.data.empresa = { ID: row.ID, Name: row.Name };
                this.changeEvent({ evento: EVENTO.consultar, data: this.data });
            }
        }
    }

    aplicacionesRowClick(cell: any) {
        this.selectedRowIndex = cell.ID;
        this.data.empresa = { ID: cell.ID, Name: cell.Name };
        this.changeEvent({ evento: EVENTO.asignar, data: this.data });
    }

    private clearMatPaginator() {
        this.pageEvent.pageIndex = 0;
        this.pageEvent.pageSize = this.pageSize;
        this.pageEvent.length = 0;
    }

    private setMatPaginator() {
        // this.paginator.length = this.pageEvent.length;
        // this.paginator.pageIndex = this.pageEvent.pageIndex;
        // this.paginator.pageSize = this.pageEvent.pageSize;
    }

    searchEmit(data: any) {
        this.buscarEmpresa(data.filtro);
    }

    changeEvent(event) {
        this.onChangeEvent.emit(event);
    }

    onNew() {
        this.changeEvent({ evento: EVENTO.crear, data: {} });
    }

    pageEventPaginator(value) {
        this.pageEvent = value;
        this.listarEmpresa(this.sectionBarComponent.filtro);
    }

    buscarEmpresa(filtro: string) {
        this.clearMatPaginator();
        this.listarEmpresa(filtro);
    }

    fabButtonEmit(action: any) {
        switch (action) {
            case ACTIONS.new:
                this.onNew();
                break;
            default:
                break;
        }
    }

    private listarEmpresa(filtro: string): void {
        this.loaderService.show();
        this.empresaService.listarEmpresa(filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
            .subscribe(res => {
                this.dataSource = new GridDataSource(res);
                this.showHideMessageGridEmpty(Number(res.length));
                this.pageEvent.length = res.length;
                this.setMatPaginator();
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }


    public showHideMessageGridEmpty(rows: number) {
        this.showMessageGridEmpty = false;
        if (rows <= 0) this.showMessageGridEmpty = true;
    }
}

